import { render, staticRenderFns } from "./tab-item.vue?vue&type=template&id=7d3a46dc&scoped=true&lang=pug"
import script from "./tab-item.vue?vue&type=script&lang=js"
export * from "./tab-item.vue?vue&type=script&lang=js"
import style0 from "./tab-item.vue?vue&type=style&index=0&id=7d3a46dc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3a46dc",
  null
  
)

export default component.exports